import React from "react";
import "./CardSection.css";

const CardSection = ({
  title,
  image,
  description,
  bgColor = "#ffffff",
  textColor = "#000000",
  titleColor = "#000000",
  topLeftPattern,
  bottomRightPattern
}) => {
  return (
    <div className="card-section container" style={{ backgroundColor: bgColor, color: textColor }}>
      {/* Corner Patterns */}
      {topLeftPattern && <img src={topLeftPattern} alt="" className="pattern top-left" />}
      {bottomRightPattern && <img src={bottomRightPattern} alt="" className="pattern bottom-right" />}

      {/* Title */}
      <h2 className="card-title" style={{ color: titleColor }}>
        {title}
      </h2>

      {/* Image */}
      <div className="card-image">
        <img src={image} alt={title} />
      </div>

      {/* Description */}
      <div className="card-description">
        {description.map((para, index) => (
          <p key={index}>{para}</p>
        ))}
      </div>
    </div>
  );
};

export default CardSection;
